import { render, staticRenderFns } from "./FormRascunho.vue?vue&type=template&id=0c96bc28&scoped=true"
import script from "./FormRascunho.vue?vue&type=script&lang=js"
export * from "./FormRascunho.vue?vue&type=script&lang=js"
import style0 from "./FormRascunho.vue?vue&type=style&index=0&id=0c96bc28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c96bc28",
  null
  
)

export default component.exports